export const CLOUD_PAYMENTS_URL = 'https://cloudpayments.ru/';
